<template>

    <div class="envelop__screen noselect">

        <markdown :color="'#5ea774'" :text="computedTitle" class="envelop__text"></markdown>

        <div class="envelop__container">

            <img v-for="number in 100" :src="isImgOpen(number)" class="envelop__img">

        </div>


    </div>


</template>

<script>

import Markdown from '@/components/Markdown'

export default {

    name: 'envelop',

    components: {Markdown},

    props: {

        data: {
            type: Object,
            default: () => {
            }
        }
    },

    computed: {

        computedTitle: function () {
            return this.$tc('stories_screen_3_text', 0, {openRate: this.data.value})
        }
    },

    methods: {

        isImgOpen(number) {
            return this.data.value <= number - 1 ? '/img/icons/newsletterFill@2x.png' : '/img/icons/newsletterOpenFill@2x.png'
        }

    }

}

</script>

<style lang="scss" scoped>

.envelop {
    &__screen {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        background-color: $rifle;
        color: $sand;
        padding: 98px 24px 64px;
        align-items: center;
        justify-content: space-between;
    }

    &__text {
        font-size: 22px;
        font-weight: bold;
        text-align: center;
    }

    &__container {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }

    &__img {
        object-fit: contain;
        width: 10%;
    }
}

</style>

